import api from './api';

export function getDesks(idAdvisor) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/asesores/${idAdvisor}/regiones/oficinas`);
}

export function getPiloto(idOficina) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/piloto/${idOficina}`);
}

export function getPermiteCambio(idCliente) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/cambio-permitido/${idCliente}`);
}

export function getPilotoValidacionIdentidad(idOficina) {
  return api.get(`${process.env.REACT_APP_INSTANCE}${process.env.REACT_APP_ENVIROMENT}onboardingservices/oficina-autovalidacion/${idOficina}`);
}
